"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 15978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OnLoadTimeline": function() { return /* binding */ OnLoadTimeline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10990);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25317);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var typewriter_effect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5459);
/* harmony import */ var typewriter_effect__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typewriter_effect__WEBPACK_IMPORTED_MODULE_4__);
/* eslint-disable @next/next/no-img-element */ 






gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].registerPlugin */ .ZP.registerPlugin((gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_6___default()));
var OnLoadTimeline = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
    defaults: {
        duration: 1.4
    }
}).pause();
function Hero() {
    var tl = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    var tl1 = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    var tl2 = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    var tl3 = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isTypeWritterPlay = ref[0], setIsTypeWritterPlay = ref[1];
    var whoWeAreStatus = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var whoWeAreTopImg = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var heroWhoWEAre = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var whoWeAreDec = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setTimeout(function() {
            setIsTypeWritterPlay(true);
        }, 1100);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useLayoutEffect)(function() {
        OnLoadTimeline.to("._topMoreButton", {
            opacity: 1,
            x: 0,
            delay: 0.2
        }, "start");
        tl2.to(heroWhoWEAre.current, {
            x: 0,
            opacity: 1,
            delay: 0.2
        }, "start");
        tl3.to(whoWeAreDec.current, {
            y: 0,
            opacity: 1,
            delay: 0.2
        }, "start");
        tl.to(whoWeAreStatus.current, {
            ease: gsap__WEBPACK_IMPORTED_MODULE_7__/* .Power2.easeOut */ .Lp.easeOut,
            delay: 0.4,
            width: "100%",
            duration: 1.5
        });
        tl1.to(whoWeAreTopImg.current, {
            ease: gsap__WEBPACK_IMPORTED_MODULE_7__/* .Power2.easeOut */ .Lp.easeOut,
            delay: 0.4,
            "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            duration: 1.5
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-0 top-0 w-[50.5%] desktop:w-1/2 h-full hidden lg:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute top-0 left-0 h-full bg-primary",
                    ref: whoWeAreStatus
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: function() {
                    return gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].to */ .ZP.to(window, {
                        duration: 0,
                        scrollTo: {
                            y: "#TopToDown",
                            offsetY: 0
                        }
                    });
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("hidden lg:flex absolute cursor-pointer bottom-0 right-0 md:left-0 text-red bg-primary h-[15rem] items-center justify-center w-[5rem]", "_topMoreButton"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative -rotate-90 -translate-y-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block w-[70px] h-[2px] bg-white -translate-x-full absolute top-1/2 -left-[70%]", "_topMoreButtonLine")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-white font-primary inline-block -ml-[10px]",
                            children: "More"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-0 lg:h-screen pt-[100px] lg:p-[70px] grid grid-cols-1 lg:grid-cols-[38.5%,61.5%]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center px-10 lg:pr-0 lg:pl-[55px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    ref: heroWhoWEAre,
                                    className: "flex items-center mt-3 lg:mt-[10px] gap-5 -translate-x-6 opacity-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "w-[1.5rem] inline-block h-[2px] bg-primary"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            className: "text-[#131313] font-semibold text-[.92857rem] leading-[1.1875em] tracking-[.13286rem]",
                                            children: "ABOUT"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    ref: whoWeAreDec,
                                    className: "translate-y-6 opacity-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "leading-[1.22222em] text-[2.57143rem] lg:text-[1.71429rem] xl:text-[2.57143rem] text-[#131313] font-light lg:max-w-[25rem] mt-[3.57143rem] mb-[3.71429rem]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    className: "font-bold",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((typewriter_effect__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        options: {
                                                            strings: [
                                                                "Experienced",
                                                                "Independent",
                                                                "Agile"
                                                            ],
                                                            autoStart: isTypeWritterPlay,
                                                            deleteSpeed: 30,
                                                            delay: 70,
                                                            loop: true,
                                                            cursor: ""
                                                        }
                                                    })
                                                }),
                                                " ",
                                                "digital innovators."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-[#4a4a4a] pt-[26px] text-[14px] lg:mr-[4.3rem] xl:mr-[2.5rem] desktop:mr-[11rem] space-y-5 hidden lg:block",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                            children: "Creative solutions "
                                                        }),
                                                        " designed to improve user's digital experiences — and making meaningful impact for clients."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        "A fundamental ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                            children: " love of challenge "
                                                        }),
                                                        " defines Digital Gregg."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative pl-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: whoWeAreTopImg,
                                className: "relative hidden w-full rotate-180 lg:block whoWeAreTopImg ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/who_we_are/who-are-we.webp",
                                    alt: "BG image",
                                    className: "h-[calc(100vh-10rem)] w-full object-cover -rotate-180 object-[50%_50%]"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-primary h-[88.56383vw] landscape:h-[50vw] flex justify-end mt-[62px] lg:hidden ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute left-10 bottom-10 w-full h-[88.56383vw] landscape:h-[50vw]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/who_we_are/who-are-we.webp",
                                        alt: "BG image",
                                        layout: "fill",
                                        className: "scale-x-125 landscape:scale-x-100 "
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[#4a4a4a] lg:hidden leading-5 text-[1rem] lg:text-[14px] lg:max-w-[67%] space-y-5 mt-[65px] lg:mt-16 px-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "Creative solutions "
                            }),
                            " designed to improve user's digital experiences — and making meaningful impact for clients."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "A fundamental ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: " love of challenge "
                            }),
                            " defines Digital Gregg."
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Hero);


/***/ })

}]);